import ManageTopics from './ManageTopics'

export default ManageTopics